/**
 * Количество загружаемых товаров по умолчанию
 */
export const LIMIT = 30;
/**
 * ID поля в url, в котором лежит текущая сортировка
 */
export const querySortId = 'sortby';
/**
 * Поле в cookie, в котором отображается корзина
 */
export const cartInfo = 'cartInfo';

export const GO_BACK_KEY = 'calculator.ui.go-back';

export const CLOSE_MODAL_KEY = 'calculator.ui.close-modal';

/**
 * Search query name for pagination
 */
export const paginationItemQuery = 'page';
